module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noneMatching":"No matching videos found"}}')
  delete Component.options._Ctor
}
